import { Department } from './department';
import { Role } from './role';
import { PropertyPrivilege } from './property-privilege';

export class SignedInUserContract {
    constructor(
        public id: number,
        public username: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public fullName: string,
        public active: boolean,
        public department: Department,
        public migrated: boolean,
        public demo: boolean,
        public password: string,
    ) {}
}

export class SignedInUser {
    constructor(
        public id: number,
        public username: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public fullName: string,
        public active: boolean,
        public department: Department,
    ) {
        if (!fullName) {
            if (this.firstName && this.lastName) {
                this.fullName =  this.firstName.trim() + ' ' + this.lastName.trim();
            } else if (this.firstName && !this.lastName) {
                this.fullName =  this.firstName.trim();
            } else if (!this.firstName && this.lastName) {
                this.fullName =  this.lastName.trim();
            } else {
                this.fullName = 'N/A';
            }
        }
    }
}

export interface UserInviteContract {
    id: string;
    organizationId: string;
    email: string;
    firstName: string;
    lastName: string;
    role: Role;
    propertyPrivileges: PropertyPrivilege[];
    department?: Department;
}

export class UserInviteContractV3 {
    constructor(
        public id: string,
        public hotelChainId: number,
        public email: string,
        public firstName: string,
        public lastName: string,
        public defaultHotelId: number,
        public hotelPrivileges: any,
        public department?: Department,
    ) {}
}

export class UserCreateInviteContract {
    constructor(
        public id: string,
        public organizationId: string,
        public email: string,
        public firstName: string,
        public lastName: string,
        public role: Role,
        public propertyPrivileges: PropertyPrivilege[],
        public department?: Department,
    ) {}
}

export interface UserOnboarding {
    email: string;
    firstName: string;
    lastName: string;
    token: string;
    ttl: number;
    hasBeenCompleted: boolean;
}

export interface SignupUser {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    department: Department;
}

export interface User {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    department: Department;
    role: Role;
    properties: PropertiesAccessCount;
    status: string;
}

export interface PropertiesAccessCount {
    data?: number;
    admin?: number;
}

export interface UserOrganizationAccess {
    role: Role;
    roleDescription: string;
    properties: PropertyAccess;
}

export interface HotelAccess {
    id: number;
    code: string;
    name: string;
    city: string;
    countryCode: string;
    enabled: boolean;
    owned: boolean;
    dataSources: { code: string; enabled: boolean }[];
}

export interface PropertyAccess {
    hotels: HotelAccess[];
}

export interface UserAccessUpdateRequest {
    userId: number;
    orgId: string;
    role: Role;
    properties: PropertyAccessUpdateRequest;
}

export interface PropertyAccessUpdateRequest {
    hotels: UserHotelAccessUpdateRequest[];
}

export interface UserHotelAccessUpdateRequest {
    id: number; // hotel id
    owned: boolean; // true if user has property-admin role and admin to this
    enabled: boolean; // true if user has access (as soon as the hotel is assigned to the user)
    dataSources: { code: string; enabled: boolean }[]; // all dataSources should be present, even if enabled = false
}

export interface UserProfileUpdateRequest {
    userId: number;
    firstName: string;
    lastName: string;
    department: Department;
}

export enum MfaType {
    TOTP = 'TOTP',
    EMAIL = 'EMAIL',
}
